export enum SectionName {
  GENERAL = "General",
  FERTILITY = "Fertility",
  ADOPTION = "Adoption",
  PRESERVATION = "Preservation",
  GESTATIONAL = "Gestational",
  PREGNANT_AND_POSTPARTUM = "Pregnant And Postpartum",
  METABOLIC = "Metabolic",
  GENDER_AFFIRMING_CARE = "Gender Affirming Care",
  MENOPAUSE = "Menopause",
  LOW_TESTOSTERONE = "Low Testosterone"
}

export enum GeneralSteps {
  BEFORE_YOU_CONTINUE = "Before You Continue",
  WHAT_IS_EXPENSE_RELATED_TO = "What Is Expense Related To",
  TOTAL_COST = "Total Cost",
  CANCEL_EXISTING_AUTH = "Cancel Existing Auth",
  SUBMIT_AUTHORIZATION = "Submit Authorization",
  CARROT_CARD_READY_TO_USE = "Carrot Card Ready To Use",
  APPEARS_TO_BE_QME = "Appears To Be QME",
  NO_FUNDS_AVAILABLE = "No Funds Available"
}

export enum FertilitySteps {
  RELATED_TO_STORAGE_FEES = "Related To Storage Fees",
  FERTILITY_TO_PRESERVATION_WARNING = "Fertility To Preservation Warning",
  WHO_WILL_RECEIVE_CARE_FERTILITY = "Who Will Receive Care Fertility",
  WHAT_KIND_FERTILITY_CARE = "What Kind Fertility Care",
  RECEIVE_CARE_FROM_ELIGIBLE_PROVIDER = "Receive Care From Eligible Provider",
  PLEASE_CONFIRM_TWO_THINGS_OBGYN = "Please Confirm Two Things OB/GYN",
  HOW_MANY_IUI_CYCLES = "How Many IUI Cycles",
  RELATED_TO_MEDICATION_EXPENSES = "Related To Medication Expenses",
  INTENDED_CARRIER = "Intended Carrier",
  THIS_IS_GESTATIONAL_SURROGACY = "This Is Gestational Surrogacy",
  EXPENSE_NOT_COVERED = "Expense Not Covered",
  COMPLETE_IVF_REQUIREMENTS = "Complete IVF Requirements",
  RELATED_TO_INFERTILITY_DIAGNOSIS = "Related To Infertility Diagnosis",
  RELATED_TO_MEDICATION_EXPENSES_CARROT_RX = "Related To Medication Expenses Carrot Rx",
  CARE_CONSIDERED_MEDICALLY_NECESSARY = "Care Considered Medically Necessary",
  CARROT_CARD_CANT_BE_USED = "Carrot Card Can't Be Used Fertility"
}

export enum AdoptionSteps {
  WHO_WILL_RECEIVE_CARE_ADOPTION = "Who Will Receive Care Adoption",
  RELATED_TO_ADOPTING_SPOUSE_CHILD = "Related To Adopting Spouse Child",
  EXPENSE_NOT_COVERED_ADOPTION = "Expense Not Covered Adoption"
}

export enum PreservationSteps {
  RELATED_TO_STORAGE_FEES_PRESERVATION = "Related To Storage Fees Preservation",
  EXPENSE_NOT_COVERED_PRESERVATION = "Expense Not Covered Preservation",
  WHO_WILL_RECEIVE_CARE_PRESERVATION = "Who Will Receive Care Preservation",
  RELATED_TO_PELVIC_FLOOR = "Related To Pelvic Floor Preservation",
  CARROT_CARD_CANT_BE_USED = "Carrot Card Can't Be Used Preservation",
  RELATED_TO_MEDICATION_EXPENSES_PRESERVATION = "Related To Medication Expenses Preservation",
  RELATED_TO_INFERTILITY_DIAGNOSIS_PRESERVATION = "Related To Infertility Diagnosis Preservation",
  CONSIDERED_MEDICALLY_NECESSARY_PRESERVATION = "Considered Medically Necessary Preservation"
}

export enum GestationalSteps {
  RELATED_TO_STORAGE_FEES_GC = "Related To Storage Fees Gestational",
  WHO_WILL_RECEIVE_CARE_GC = "Who Will Receive Care Gestational",
  RELATED_TO_MEDICATION_EXPENSES_GC = "Related To Medication Expenses Gestational",
  EXPENSE_NOT_COVERED_GC = "Expense Not Covered Gestational"
}

export enum PregnantPostpartumSteps {
  CARROT_CARD_CANT_BE_USED = "Carrot Card Can't Be Used Pregnancy And Postpartum"
}

export enum MetabolicSteps {
  WHO_WILL_RECEIVE_CARE_METABOLIC = "Who Will Receive Care Metabolic",
  WHAT_KIND_OF_METABOLIC_EXPENSE = "What Kind Of Metabolic Expsense",
  EXPENSE_NOT_COVERED_METABOLIC = "Expense Not Covered Metabolic"
}

export enum GenderAffirmingCareSteps {
  WHO_WILL_RECEIVE_CARE_GAC = "Who Will Receive Care Gender Affirming Care",
  WHAT_KIND_GENDER_AFFIRMING_CARE = "What Kind Gender Affirming Care",
  PLEASE_CONFIRM_ONE_THING = "Please Confirm One Thing",
  PLEASE_CONFIRM_TWO_THINGS = "Please Confirm Two Things",
  CARROT_CARD_CANT_BE_USED = "Carrot Card Can't Be Used Gender Affirming Care",
  EXPENSE_NOT_COVERED_GAC = "Expense Not Covered Gender Affirming Care"
}

export enum MenopauseSteps {
  WHO_WILL_RECEIVE_CARE_MENOPAUSE = "Who Will Receive Care Menopause",
  WHAT_KIND_MENOPAUSE_EXPENSE = "What Kind Menopause Expense",
  CARROT_CARD_CANT_BE_USED = "Carrot Card Can't Be Used",
  PLEASE_CONFIRM_TWO_THINGS = "Please Confirm Two Things",
  EXPENSE_NOT_COVERED_MENOPAUSE = "Expense Not Covered Menopause"
}

export enum LowTestosteroneSteps {
  WHO_WILL_RECEIVE_CARE_LOW_T = "Who Will Receive Care Low Testosterone",
  WHAT_KIND_LOW_TESTOSTERONE = "What Kind Low Testosterone",
  PLEASE_CONFIRM_TWO_THINGS = "Please Confirm Two Things",
  CARROT_CARD_CANT_BE_USED = "Carrot Card Can't Be Used Low Testosterone",
  EXPENSE_NOT_COVERED_LOW_T = "Expense Not Covered Low Testosterone"
}
